import React, { useState, useEffect, useRef } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
  Button,
  Slide,
  InputAdornment,
} from "@mui/material";

import { useForm } from "react-hook-form";

import TextField from "@mui/material/TextField";
import LockIcon from "@mui/icons-material/Lock";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Snackbar from "@mui/material/Snackbar";
import LogoGeosoftsolutions from "../assets/LogoGeosoftsolutions.png";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function ScriptDownload() {
  const [open, setOpen] = useState(true);

  //snackbar de alertas
  const [snackbar, setSnackbar] = React.useState({
    open: false,
    message: "",
  });

  //react-hook-form
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  //cierra el dialog
  const handleClose = () => {
    setOpen(false);
  };

  //cierra el snackbar
  const handleSnackBarClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbar({ ...snackbar, open: false });
  };

  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const hashPassword = async (password) => {
    const encoder = new TextEncoder();
    const data = encoder.encode(password);
    const hashBuffer = await crypto.subtle.digest("SHA-256", data);
    return Array.from(new Uint8Array(hashBuffer))
      .map((b) => b.toString(16).padStart(2, "0"))
      .join("");
  };

  const passwordSafe =
    "46cd00b2008d21629efe772550fa80a647113a22725e714da90d24e624f42e86";

  //envia el mensaje
  const onSubmit = async (data) => {
    try {
      const passwordEncrypt = await hashPassword(data.password);

      if (passwordEncrypt === passwordSafe) {
        const link = document.createElement("a");
        link.href = "/media/SmartMineCode_Scripts_MediaLuna.zip"; // URL del documento
        link.download = "SmartMineCode_Scripts_MediaLuna.zip"; // Nombre con el que se guardará
        //link.target = "_blank"; // Opcional: abre en otra pestaña
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        setSnackbar({ message: "Decarga del zip iniciada ...", open: true });
      } else {
        setSnackbar({ message: "Contraseña incorrecta", open: true });
      }
    } catch (ex) {
      setSnackbar({ message: "Ocurrió un error intente de nuevo", open: true });
    } finally {
      //limpia los datos despues de mandar una solicitud
      reset();
    }
  };

  //action snackbar
  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleSnackBarClose}
      >
        <CloseIcon fontSize="small" className="text-amarillo" />
      </IconButton>
    </React.Fragment>
  );

  //estilo de los componentes
  const styleText = {
    input: { color: "white", fontSize: "14px" },
    textarea: { color: "white", fontSize: "14px" },
    label: { color: "white", fontSize: "14px" },
    "&:hover label": {
      color: "#ffc107", // color al hacer hover
    },
    "& label.Mui-focused": {
      color: "#ffc107",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "white", // línea antes del enfoque
    },
    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
      borderBottomColor: "#ffc107", // línea al hacer hover
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#ffc107", // línea después del enfoque
    },
    "& .MuiFormHelperText-root": {
      color: "#e57373", // color helper error
    },
    "& .MuiInputLabel-root.Mui-error": {
      color: "#e57373", // label cuando hay error
    },
    marginTop: "10px",
    marginBottom: "10px",
  };

  return (
    <>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackBarClose}
        message={snackbar.message}
        action={action}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        ContentProps={{
          sx: {
            color: "#fffcfc",
          },
        }}
      />
      <Dialog
        open={open}
        slots={{
          transition: Transition,
        }}
        keepMounted
        onClose={handleClose}
        sx={{
          "& .MuiPaper-root": {
            backgroundColor: "#555b5e", // color de fondo del dialog
          },
        }}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <img
              className="w-[220px] h-auto mx-auto"
              src={LogoGeosoftsolutions}
              alt="logo"
            />
            <span className="text-blanco">
              Digite la contraseña para descargar el documento.
            </span>
          </DialogContentText>

          <form
            className="space-y-4 md:space-y-6"
            onSubmit={handleSubmit(onSubmit)}
          >
            <TextField
              required
              type={showPassword ? "text" : "password"}
              id="password"
              defaultValue=""
              label="Contraseña"
              variant="standard"
              sx={styleText}
              fullWidth
              error={!!errors.password}
              helperText={errors.password ? "Campo faltante" : ""}
              {...register("password", { required: true, maxLength: 80 })}
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <LockIcon className="text-amarillo" fontSize="10" />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment
                      position="start"
                      onClick={handleClickShowPassword}
                      className="cursor-pointer"
                    >
                      {showPassword ? (
                        <VisibilityOff
                          className="text-amarillo"
                          fontSize="10"
                        />
                      ) : (
                        <Visibility className="text-amarillo" fontSize="10" />
                      )}
                    </InputAdornment>
                  ),
                },
              }}
            />
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>
            <span className="text-rojo"> Cerrar </span>
          </Button>
          <Button onClick={handleSubmit(onSubmit)}>
            <span className="text-amarillo"> Aceptar </span>
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ScriptDownload;
